import { isCategoryMetas, isCombinationMetas } from '@/app/(plp)/_utils/type-guards'
import { PLPBasicMetasProps, PLPPages } from '@/app/(plp)/types'

export const createBreadCrumbItems = (page: PLPPages, basicMetas: PLPBasicMetasProps | undefined) => {
    switch (page) {
        case PLPPages.BrandCategoriesCombination: {
            const metas = isCombinationMetas(page, basicMetas) ? basicMetas : undefined

            const breadcrumb = [...(metas?.breadcrumb || [])]

            breadcrumb.push({
                nameFa: metas?.seoH1 || '',
            })

            return breadcrumb
        }

        case PLPPages.Categories:
            return isCategoryMetas(page, basicMetas) ? basicMetas.breadcrumb : null

        default:
            return null
    }
}
